import React from 'react';
import moment from 'moment';
import ModalEnabled from '../extend/ModalEnabled';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import BigCalendar, {
  formatTimeGutter,
  formatDateRange,
  formatDate,
} from '../shared/BigCalendar';
import ServicesCalendarAgendaEvent from '../services/ServicesCalendarAgendaEvent';
import ServicesCalendarEvent from '../services/ServicesCalendarEvent';
import ServicesCalendarMonthEvent from '../services/ServicesCalendarMonthEvent';
import ServicesCalendarEventWrapper from '../services/ServicesCalendarEventWrapper';
import ServiceSendDetailsModal from '../service/ServiceSendDetailsModal';
import ServicesEventModal from '../services/ServicesEventModal';
import ServicesCreateModal from '../services/ServicesCreateModal';
import SearchInput from '../form/SearchInput';
import CheckboxDropdown from '../form/CheckboxDropdown';
import { debounce, getLatestRequest } from '../../helpers/util';
import timeZoneOffset from '../../helpers/timeZoneOffset';
import ServicesExportModal from '../services/ServicesExportModal';
import SVGDownload from '../../svg/Download';
import Loader from '../shared/Loader';
import withTracker from '../withTracker';
import {
  createZipMap,
  renderLocation,
} from '../../helpers/serviceDistrictHelpers.js';

import {
  ServiceCalendarContext,
  ServiceCalendarProvider,
} from './ServiceCalendarContext';
const CAL_STARTING_VIEW = 'agenda';

class AdminServicesCalendar extends ModalEnabled {
  state = {
    searchTermChef: JSON.parse(sessionStorage.getItem('searchTermChef')) || '',
    searchTermClient:
      JSON.parse(sessionStorage.getItem('searchTermClient')) || '',
    events: [],
    pagination: {},
    isLoading: true,
    date: new Date(),
    view:
      JSON.parse(sessionStorage.getItem('calendarView')) || CAL_STARTING_VIEW,
    weekly: JSON.parse(sessionStorage.getItem('weekly')) || false,
    custom_weekly: JSON.parse(sessionStorage.getItem('custom_weekly')) || false,
    occasion: JSON.parse(sessionStorage.getItem('occasion')) || false,
    marketing_occasion:
      JSON.parse(sessionStorage.getItem('marketing_occasion')) || false,
    custom_occasion:
      JSON.parse(sessionStorage.getItem('custom_occasion')) || false,
    cooking_class:
      JSON.parse(sessionStorage.getItem('cooking_class')) || false,
    service_districts:
      JSON.parse(sessionStorage.getItem('service_districts')) || [],
    isLoadingActiveService: false,
    activeService: {},
    zipMap: {},
  };

  components = {
    event: ServicesCalendarEvent,
    eventWrapper: ServicesCalendarEventWrapper,
    month: {
      event: ServicesCalendarMonthEvent,
    },
    agenda: {
      event: ServicesCalendarAgendaEvent,
    },
  };

  formats = {
    timeGutterFormat: formatTimeGutter,
    eventTimeRangeFormat: formatDateRange,
    eventTimeRangeStartFormat: formatDate,
    eventTimeRangeEndFormat: formatDate,
  };

  agendaStartHour = new Date();
  agendaEndHour = new Date();

  render() {
    const {
      agendaStartHour,
      agendaEndHour,
      handleChange,
      handleLocationChange,
      isOpen,
      closeModal,
      handleClearLocations,
      handleClearServiceTypes,
    } = this;
    const {
      searchTermChef,
      searchTermClient,
      events,
      view,
      isLoading,
      occasion,
      weekly,
      custom_weekly,
      marketing_occasion,
      custom_occasion,
      cooking_class,
    } = this.state;

    const serviceFilterOptions = [
      {
        name: 'Weekly',
        key: 'weekly',
        checked: weekly,
        class: 'checkbox--small-green',
      },
      {
        name: 'Custom Weekly',
        key: 'custom_weekly',
        checked: custom_weekly,
        class: 'checkbox--small-gold',
      },
      {
        name: 'Occasion',
        key: 'occasion',
        checked: occasion,
        class: 'checkbox--small-blue',
      },
      {
        name: 'Marketing Occasion',
        key: 'marketing_occasion',
        checked: marketing_occasion,
        class: 'checkbox--small-red',
      },
      {
        name: 'Custom Occasion',
        key: 'custom_occasion',
        checked: custom_occasion,
        class: 'checkbox--small-orange',
      },
      {
        name: 'Cooking Class',
        key: 'cooking_class',
        checked: cooking_class,
        class: 'checkbox--small-gray-blue',
      },
    ];

    return (
      <ServiceCalendarProvider>
        <div className="products cms">
          <div className="cms__head cms__head--padding">
            <div className="cms__content">
              <div className="cms__bar">
                <div className="cms__bar-left">
                  <h1 className="h2">Service Calendar</h1>
                </div>
                <div className="cms__bar-right">
                  <div className="cms__bar-ctas">
                    <div
                      className="btn-icon btn-icon--download"
                      onClick={() => this.openModal('services-export')}
                    >
                      <SVGDownload />
                    </div>
                    <div
                      className="btn btn--solid-blue"
                      onClick={() => this.openModal('add-service')}
                    >
                      Add a New Service
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cms__body">
            <div className="cms__content">
              <div className="cms__bar">
                <div className="cms__bar-left">
                  <SearchInput
                    placeholder="Enter Chef Name to See Availability"
                    value={searchTermChef}
                    onChange={handleChange}
                    name="searchTermChef"
                  />
                </div>
                <div className="cms__bar-left">
                  <CheckboxDropdown
                    title="Locations"
                    options={this.state.service_districts}
                    onChange={handleLocationChange}
                    disabled={isLoading}
                    onClear={handleClearLocations}
                  />
                  <CheckboxDropdown
                    title="Services"
                    options={serviceFilterOptions}
                    onChange={handleChange}
                    disabled={isLoading}
                    onClear={handleClearServiceTypes}
                  />
                </div>
                <div className="cms__bar-right">
                  <SearchInput
                    placeholder="Search by Client"
                    value={searchTermClient}
                    onChange={handleChange}
                    name="searchTermClient"
                  />
                </div>
              </div>

              {isLoading && <Loader />}

              <div className="service-calendar">
                <ServiceCalendarContext.Consumer>
                  {(contextProps) => (
                    <BigCalendar
                      length={7}
                      events={events}
                      min={agendaStartHour}
                      max={agendaEndHour}
                      components={this.components}
                      formats={this.formats}
                      onNavigate={this.handleNavigate}
                      onView={this.handleView}
                      defaultDate={new Date()}
                      onSelectEvent={contextProps.handleSelectEvent}
                      defaultView={view}
                      views={['month', 'week', 'day', 'agenda']}
                    />
                  )}
                </ServiceCalendarContext.Consumer>
                <p className="p small p--pad-top">*All times are EST</p>
              </div>
            </div>
          </div>

          <ServiceCalendarContext.Consumer>
            {(contextProps) => (
              <ServicesEventModal
                isOpen={contextProps.openModal === 'service-event'}
                closeModal={contextProps.closeModal}
                service={contextProps.activeService}
                isLoading={contextProps.isLoadingActiveService}
                zipMap={this.state.zipMap}
                openSendDetailsModal={(audience) => {
                  contextProps.sendServiceDetailsEmail(contextProps.activeService, audience)
                }}
              />
            )}
          </ServiceCalendarContext.Consumer>
          <ServiceCalendarContext.Consumer>
            {contextProps => {
                const { activeService: service, sendDetailsAudience: audience } = contextProps;
                return <ServiceSendDetailsModal
                  isOpen={contextProps.openModal === 'send-details'}
                  closeModal={() => {
                    contextProps.getServiceDetails(service)
                  }}
                  service={service}
                  audience={audience}
                />
            }}
          </ServiceCalendarContext.Consumer>
          <ServicesCreateModal
            isOpen={isOpen('add-service')}
            closeModal={closeModal}
          />
          <ServicesExportModal
            isOpen={isOpen('services-export')}
            closeModal={closeModal}
          />
        </div>
      </ServiceCalendarProvider>
    );
  }

  setActiveService = (service) => {
    // go ahead and set it with the partial data
    this.setState({
      openModal: 'service-event',
      activeService: service,
      isLoadingActiveService: true,
    });

    // then load the full service, then update state
    serviceAPI
      .getService(service.id)
      .then((activeService) =>
        this.setState({ activeService, isLoadingActiveService: false })
      )
      .catch((error) => console.log(error));
  };

  handleSelectEvent = ({ service }, e) => {
    this.setActiveService(service);
  };

  handleChange = (e) => {
    const value =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const name = e.target.name;

    // Clear other search field if necessary so it only searches for either client or chef at one time
    if (name === 'searchTermChef' && this.state.searchTermClient) {
      this.setState({ searchTermClient: '' });
    }
    if (name === 'searchTermClient' && this.state.searchTermChef) {
      this.setState({ searchTermChef: '' });
    }

    let newState = { [name]: value };

    // Set Session Storage
    if (name === 'searchTermChef') {
      sessionStorage.setItem('searchTermChef', JSON.stringify(value));
    }
    if (name === 'searchTermClient') {
      sessionStorage.setItem('searchTermClient', JSON.stringify(value));
    }
    if (e.target.type === 'checkbox') {
      sessionStorage.setItem(name, JSON.stringify(e.target.checked));
    }

    // Set State
    this.setState(newState, this.debouncedLoadServices);
  };

  handleLocationChange = (e) => {
    const value = e.target.checked;
    const key = e.target.name;

    // get index of district to change
    const districtIx = this.state.service_districts.findIndex(
      (district) => district.id === parseInt(key, 10)
    );

    if (districtIx !== -1) {
      let districts = this.state.service_districts;
      districts[districtIx].checked = value;
      const newState = { service_districts: districts };

      // Set Session Storage
      sessionStorage.setItem('service_districts', JSON.stringify(districts));
      // Set State
      this.setState(newState, this.debouncedLoadServices);
    }
  };

  handleClearLocations = () => {
    // uncheck all boxes and reload services
    let service_districts = this.state.service_districts;
    service_districts.forEach((el) => (el.checked = false));
    const newState = { service_districts };

    // Remove Session Storage
    sessionStorage.removeItem('service_districts');

    // Set State
    this.setState(newState, this.debouncedLoadServices);
  };

  handleClearServiceTypes = () => {
    // uncheck all service types and reload services
    const newState = {
      weekly: false,
      custom_weekly: false,
      occasion: false,
      marketing_occasion: false,
      custom_occasion: false,
      cooking_class: false,
    };

    // Clear Session Storage
    for (const serviceType in newState) {
      sessionStorage.removeItem(serviceType);
    }

    // Set State
    this.setState(newState, this.debouncedLoadServices);
  };

  handleNavigate = (date, view, action) => {
    this.setState({ date, view }, this.loadServices);
  };

  handleView = (view) => {
    sessionStorage.setItem('calendarView', JSON.stringify(view));
    this.setState({ view }, this.loadServices);
  };

  prepareEvents(services) {
    return services.map((service) => ({
      start: new Date(service.start_time),
      end: new Date(service.end_time),
      service,
      location: renderLocation(service, this.state.zipMap),
    }));
  }

  getTimezoneDifference() {
    const gmt = moment(new Date()).tz('GMT');
    const newYork = moment(new Date()).tz('America/New_York'); // NY time is default
    return (gmt._offset - newYork._offset) / 60; // Difference in Hours
  }

  getQueryDates() {
    // NOTE:  Services saved in GMT.  Query dates therefore must be offset to include service times that may fall in the next day.  e.g. (8:30 - 11pm EST / GMT -4)
    const tzDiff = this.getTimezoneDifference();

    const { date, view } = this.state;
    // Agenda view
    if (view === 'agenda') {
      const start = moment(date).startOf('day').toString();
      const end = moment(date)
        .add(1, 'week')
        .endOf('day')
        .add(tzDiff, 'hour')
        .toString();
      return { start, end };
    }

    // Month / Week / Day
    const start = moment(date).startOf(view).toString();
    const end = moment(date).endOf(view).add(tzDiff, 'hour').toString();

    return { start, end };
  }

  getServiceType() {
    const { weekly, occasion, custom_weekly, marketing_occasion, custom_occasion, cooking_class } = this.state;

    const serviceTypes = [];
    if (weekly) serviceTypes.push('weekly');
    if (custom_weekly) serviceTypes.push('custom_weekly');
    if (occasion) serviceTypes.push('occasion');
    if (marketing_occasion) serviceTypes.push('marketing_occasion');
    if (custom_occasion) serviceTypes.push('custom_occasion');
    if (cooking_class) serviceTypes.push('cooking_class');

    return serviceTypes;
  }

  getServiceDistricts = () => {
    serviceAPI
      .getServiceDistricts()
      .then(({ service_districts }) => {
        // format service districts along the same lines as other checkbox instances
        this.setState({
          service_districts: service_districts.map((district) => {
            return { ...district, checked: false, key: district.id };
          }),
          zipMap: createZipMap(service_districts),
        });
      })
      .catch((error) => console.log(error));
  };

  loadServices = () => {
    this.setState({
      isLoading: true,
      events: [],
    });

    const { start: start_date, end: end_date } = this.getQueryDates();
    const service_type = this.getServiceType();
    const { searchTermChef: chef_name, searchTermClient: client_name } =
      this.state;

    let searchParams = {
      page: 1,
      search: {
        chef_name,
        service_type,
        start_date,
        end_date,
        client_name,
      },
    };

    // include service_districts in search once selected
    if (
      this.state.service_districts.filter((district) => district.checked).length
    ) {
      const service_districts = this.state.service_districts
        .filter((district) => district.checked)
        .map((district) => district.id.toString(10));

      searchParams.search.service_districts = service_districts;
    }

    getLatestRequest(
      'searchServices',
      serviceAPI.searchServices(searchParams),
      ({ services }) => {
        if (!services) {
          this.setState({
            isLoading: false,
          });
          return;
        }
        const preparedEvents = this.prepareEvents(services);
        const events = this.removePausedEvents(preparedEvents);

        this.setState({
          events,
          isLoading: false,
        });
      },
      (error) => console.log(error)
    )
  };

  timestamp(string) {
    return Math.round(new Date(string).getTime() / 1000);
  }

  removePausedEvents(events) {
    return events.filter((item) => {
      // Pause filter only for "weekly" & "custom_weekly" service types.
      if (item.service.service_type.includes('weekly')) {
        if (!item.service.client.pause_end_date) return true;

        // If service start date is greater tha pause start date
        // AND service end date is less the pause end date
        let serviceStartTime = this.timestamp(item.start);
        let pauseStartTime = this.timestamp(
          item.service.client.pause_start_date
        );
        let pauseEndTime = this.timestamp(item.service.client.pause_end_date);

        // Keep service that are before the pause
        if (serviceStartTime < pauseStartTime) return true;

        // Keep services that are after the pause
        if (serviceStartTime > pauseEndTime) return true;

        // LOG admin client links for clients slipping through the backend removal of paused services somehow
        console.log(`/admin/client/${item.service.client.id}`);
        // Discard the rest
        return false;
      } else {
        return true;
      }
    });
  }

  // react's correct implementation of debounce
  debouncedLoadServices = debounce(() => this.loadServices(), 250);

  componentDidMount() {
    this.agendaStartHour.setHours(timeZoneOffset().open, 0, 0, 0);
    this.agendaEndHour.setHours(timeZoneOffset().close, 0, 0, 0);

    if (JSON.parse(sessionStorage.getItem('service_districts')) === null) {
      this.getServiceDistricts();
    }

    this.loadServices();
  }
}

export default withTracker(AdminServicesCalendar);



// WEBPACK FOOTER //
// ./src/components/admin/AdminServicesCalendar.js